import DataTable from "../../../components/Table";
import type { ColumnsType } from "antd/es/table";
import { Row, Col, Button, Space, Popconfirm, message, Tag } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import RoleSearch from "./RoleSearch";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import AddRole from "./add";
import { callDeleteRole } from "../../../config/api";
import ModalRole from "./edit";
import { fetchRole } from "../../../redux/slice/roleSlide";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE_DISPLAY } from "../../../utils/constants/timeFormat";
import ViewDetail from "./detail/ViewDetail";

interface DataType {
  key: string;
  name: string;
  description: number;
  tags: string[];
}
function ManageRole() {
  const [searchPagination, setSearchPagination] = useState(
    "current=1&pageSize=10&populate=permissions&fields=permissions._id,permissions.name, permissions.apiPath"
  );
  const [searchData, setSearchData] = useState("");
  const dispatch = useAppDispatch();
  const roles = useAppSelector((state) => state.role);
  const [dataViewDetail, setDataViewDetail] = useState("");
  const [openViewDetail, setOpenViewDetail] = useState(false);

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "_id",
      render: (text, record: any) => {
        return (
          <span
            style={{ color: "#4986ff", cursor: "pointer" }}
            onClick={() => {
              setDataViewDetail(record);
              setOpenViewDetail(true);
            }}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => {
        return <span style={{ color: "#1677ff" }}>{text}</span>;
      },
    },
    {
      title: "IsActive",
      dataIndex: "IsActive",
      render: (text) => {
        return <Tag color={text ? "green" : undefined}>Active</Tag>;
      },
    },
    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "UpdatedAt",
      dataIndex: "updatedAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record: any) => (
        <Space size="middle">
          <ModalRole id={record._id} handleFetchRole={handleFetchRole} />
          <Popconfirm
            placement="leftTop"
            title={"Xác nhận xóa user"}
            description={"Bạn có chắc chắn muốn xóa user này ?"}
            onConfirm={() => handleDeleteRole(record._id)}
            okText="Xác nhận"
            cancelText="Hủy">
            <Button type="primary" danger ghost>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  let query = `${searchPagination}${searchData}`;
  const handleDeleteRole = async (id: string) => {
    const result = await callDeleteRole(id);
    if (result.statusCode === 200) {
      handleFetchRole();
      message.success("delete success!");
    } else {
      message.error("delete failed!");
    }
  };

  const handleFetchRole = () => {
    dispatch(fetchRole({ query }));
  };
  useEffect(() => {
    handleFetchRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleModalCreate = (): JSX.Element => {
    return (
      <>
        <AddRole handleFetchRole={handleFetchRole} />
      </>
    );
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <RoleSearch handleSearch={setSearchData} />
        </Col>
      </Row>
      <DataTable
        columns={columns}
        data={roles?.result}
        total={roles?.meta.total}
        loading={roles.isFetching}
        modalAdd={handleModalCreate}
        name={"Roles"}
        setSearchPagination={setSearchPagination}
      />
      <ViewDetail
        openViewDetail={openViewDetail}
        dataViewDetail={dataViewDetail}
        setOpenViewDetail={setOpenViewDetail}
      />
    </>
  );
}

export default ManageRole;
